import React from 'react'
import AccountSidebar from '../../components/AccountSidebar';
import { toast } from 'react-hot-toast';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useBlogContext } from '../../../fetchdata/BlogContext';
import NavBar from '../../components/NavBar';
import HeaderPage from '../../components/HeaderPage';


const AccountSupport = () => {
  const { Headers, isHeader } = useBlogContext();

  return (
    <>
    
    <HeaderPage title={'Help & Support'}/>
    
      <main className="page-content bg-white space-top  mypadding overflow-auto pb-4 px-0" >

<div className='px-3'>
   <div className="mt-4">

    {!isHeader && (
      <>
        {/* Phone Contact */}
        <div className="d-flex align-items-center text-white bg-success p-3 mb-3 rounded shadow-sm hover-shadow-lg">
          <i className="fa-solid fa-phone-alt fa-2x me-3"></i>
          <span className="fs-5 fw-semibold">+91 {Headers.phone}</span>
        </div>

        {/* Email Contact */}
        <div className="d-flex align-items-center text-white bg-primary p-3 mb-3 rounded shadow-sm hover-shadow-lg">
          <i className="fa-solid fa-envelope fa-2x me-3"></i>
          <span className="fs-5 fw-semibold">{Headers.email}</span>
        </div>
      </>
    )}

  </div>
</div>

 
</main>
    </>
  )
}

export default AccountSupport